import React, { useState, useEffect } from 'react';
import {
    Col, Row, Label, Modal, ModalBody,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { useAppContext } from '../../state/GlobalState';
import { Info32, Remove32 } from '@bphxd/ds-core-react/icons';
import { isMobileDevice } from '../../theme/mediaHelpers';

const VirtualTerminalModal = ({
    isOpen,
    handleCancel,
}) => {

    return (
        <Modal isOpen={isOpen} className="confirm-modal" data-testid="confirm-modal" centered>
            <ModalBody>
                <Row className="d-flex flex-row-reverse pr-4">
                    <Remove32 onClick={() => { handleCancel(); }} className="add-pointer" data-testid="close-btn" />
                </Row>
                <Row className="pt-5 pb-5">
                    <Col xs={{ size: 10, offset: 1 }}>
                        <Row>
                            <Col>
                                <Label className="roboto font-20 lightweight redirect-check-modal-title" data-testid="redirect-check-modal-title">
                                    Mandatory BOL upload will be prompted when selecting the signature button.
                                </Label>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

VirtualTerminalModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleAction: PropTypes.func.isRequired,
    handleNext: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    actionInProgress: PropTypes.bool,
};

export default VirtualTerminalModal;
